import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { styles } from "../shared-styles";
import { Maybe } from "../../../utils/fp/small-fp-utils";
import { FONTS } from "../../../styles/fonts";

export const RelatedArticleSetTop: ReactTFC<{ emoHeadline: Maybe<string>; seoHeadline: Maybe<string> }> = props => {
  return (
    <React.Fragment>
      {props.emoHeadline && (
        <span
          css={css`
            ${FONTS.MinervaModern500};

            font-size: 40px;
            color: var(--so-green);

            letter-spacing: 2px;
            text-align: center;
            line-height: 42px;

            margin-bottom: 20px;

            display: block;
            text-transform: uppercase;
            max-width: 18em;
          `}
        >
          {props.emoHeadline}
        </span>
      )}
      {props.seoHeadline && (
        <span
          css={css`
            ${styles}

            margin-bottom: 50px;
          `}
        >
          {props.seoHeadline}
        </span>
      )}
    </React.Fragment>
  );
};
